// @flow
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { css } from "styled-components";
import { media, smallHeading, mediumHeading, Gravatar } from "@nested/brand";
import { getImage, scrollToById } from "@nested/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { getConfig } from "@nested/config";
import { Arrow } from "../AVMValuationResult/Arrow";
import { CheckInboxWrapper } from "./AnimatedComponents";

const { ACCOUNT_URI } = getConfig();

const agentInfoStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const arrowWrapperStyle = css`
  position: absolute;
  left: 153px;
  top: -18px;
  transform: matrix(0.96, 0.29, 0.29, -0.96, 0, 0);
  ${media.desktop`
    left: 160px;
    top: -26px;
  `}
`;

const customerEmailStyle = css`
  background: ${({ theme }) => theme.palette.hague150};
  padding: 3px;
  border-radius: 5px;
`;

const gravatarStyle = css`
  width: 45px;
  height: 45px;
  border: 5px solid white;
  margin: 0px;
  ${media.desktop`
    width: 60px;
    height: 60px;
  `}
`;

const headingStyle = css`
  ${smallHeading};
  font-size: 24px;
  color: white;
  margin-bottom: 16px;
  margin-top: 0;
  ${media.desktop`
    ${mediumHeading}
    white-space: nowrap;
    color: white;
  `}
  ${media.maxDesktop`
    font-size: 40px;
    white-space: nowrap;
    color: white;
  `}
`;

const leftColumnStyle = css`
  display: block;
  ${media.desktop`
    display: flex;
    align-items: baseline;
    flex-direction: column;
    width: calc(50% - 40px);
    max-width: 555px;
  `}
`;

const marketStatsIconStyle = css`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #f2ebe2;
  margin-right: 14px;
`;

const marketStatsStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px 20px 20px;
  color: white;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  border-top: 1px solid ${({ theme }) => theme.palette.hague70};
  ${media.desktop`
    padding-left: 0;
    border-bottom: 1px solid ${({ theme }) => theme.palette.hague70};
  `}
`;

const messageStyle = css`
  color: white;
  font-size: 16px;
  line-height: 24px;
  padding: 0 20px;
  text-align: center;
  margin: 16px auto 30px auto;
  max-width: 500px;
  ${media.desktop`
    text-align: left;
    margin: 16px 0 30px 0;
    padding: 0;
  `}
`;

const rightColumnStyle = css`
  display: none;
  ${media.desktop`
    display: inline-block;
    width: calc(50% - 40px);
  `}
  ${media.maxDesktop`
    min-width: 353px;
  `}
`;

const rmNameStyle = css`
  font-family: "Reenie Beanie";
  color: white;
  line-height: 25px;
  font-size: 30px;
  margin-left: 10px;
`;

export const CheckYourInbox = ({
  rmFirstName,
  rmEmail,
  customerEmail,
  outcode,
  delay,
}: {
  rmFirstName: string,
  rmEmail: string,
  customerEmail: ?string,
  outcode: string,
  delay: number,
}) => {
  useEffect(() => {
    setTimeout(() => scrollToById("check-inbox-wrapper"), delay);
  }, []);

  return (
    <CheckInboxWrapper id="check-inbox-wrapper" delay={delay}>
      <div css={leftColumnStyle}>
        <h1 css={headingStyle}>Check your inbox soon</h1>
        <div css={agentInfoStyle}>
          <Gravatar
            size={324}
            css={gravatarStyle}
            email={rmEmail}
            className="chromatic-ignore"
          />
          <div css="position: relative">
            <span css={rmNameStyle}>{rmFirstName}'s on it!</span>
            <div css={arrowWrapperStyle}>
              <Arrow />
            </div>
          </div>
        </div>
        <div css={messageStyle}>
          No one knows {outcode} quite like {rmFirstName}, your dedicated local
          Nested agent. They’ll drop an email{" "}
          {customerEmail ? (
            <p css="margin: 0; padding: 0; display: inline;">
              to <span css={customerEmailStyle}>{customerEmail}</span>
              with your personalised valuation
            </p>
          ) : (
            "with your personalised valuation"
          )}
          .
        </div>
        <Link
          css="width: 100%"
          to={{
            pathname: `${ACCOUNT_URI}/listing/viewings`,
          }}
          target="_blank"
        >
          <div css={marketStatsStyle}>
            <div css="display:flex; align-items: center;">
              <img
                css={marketStatsIconStyle}
                alt=""
                src={getImage("illustrations/icons_15_RGB.png")}
              />
              <span>View market stats for {outcode}</span>
            </div>
            <FontAwesomeIcon
              css="color: #CED9DD; font-size: 24px;"
              icon={faAngleRight}
            />
          </div>
        </Link>
      </div>
      <img
        css={rightColumnStyle}
        alt=""
        src={getImage("illustrations/book_valuation.png")}
      />
    </CheckInboxWrapper>
  );
};
